import { inject }             from '@angular/core';
import { ResolveFn }          from '@angular/router';
import { Observable }         from 'rxjs';
import { AccountsSummary }    from './account-data';
import { AccountDataService } from './account-data.service';

export const accountDataResolver: ResolveFn<AccountsSummary> = (): Observable<AccountsSummary> => {
  return inject(AccountDataService).loadAccounts();
};
